var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Login - Your Indoor Cycling Solution"
    }
  }), _vm._m(0), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-6 mx-auto"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h3', [_vm._v("RECOVER YOUR PASSWORD")]), _c('span', [_vm._v("Using your MyWhoosh account")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail1",
      "placeholder": "Email Address",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getErrors('email') ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v("A valid email is required")]) : _vm._e(), _vm.submitted && _vm.errorResponse ? _c('div', {
    staticClass: "text-danger text-left"
  }, [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _c('button', {
    staticClass: "btn-universal",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.resetPassword && _vm.resetPassword.key ? "Send Again" : "Submit"))]), _c('ul', {
    staticClass: "list-inline justify-content-center"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Back to Login")]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Create New Account?")])], 1)])])])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "overlay"
  }), _c('div', {
    staticClass: "sreachBar"
  }, [_c('h1', [_vm._v("Profile")])])])]);
}]

export { render, staticRenderFns }